import {
  config,
  getCompleteDomain,
  getServerEnvironment,
} from "./DynamicPortalFunctions";

const { Url } = config(getServerEnvironment(getCompleteDomain()));
export const SWIPELINC_API = Url;

export const LOGIN_API = `${SWIPELINC_API}merchant/login`;

export const IMG_SLIDE_PATH = `${SWIPELINC_API}uploads/`;

export const CHANGE_PASSWORD = `${SWIPELINC_API}merchant/passwordreset/changePassword`;

export const FORGOT_PASSWORD_API = `${SWIPELINC_API}merchant/passwordreset/forgotPassword`;

export const OTP_VERIFY_API = `${SWIPELINC_API}merchant/passwordreset/otpverify`;

export const VERIFY_MERCHANT_ONBOARD_EMAIL = `${SWIPELINC_API}merchant/onboard/verified/email`;

export const MERCHANT_ACCOUNT_DETAIL = `${SWIPELINC_API}merchant/Util/getAccountDetail`;

export const VERIFY_MERCHANT_ONBOARD_MOBILE = `${SWIPELINC_API}merchant/onboard/verified`;

export const GET_NOTIFICATION_BY_MID = `${SWIPELINC_API}merchant/notification/findByMid//`;

export const DISABLE_NOTIFICATION_BY_ID = `${SWIPELINC_API}merchant/notification/Disable/`;

export const MERCHANT_ONBOARD_SAVE = `${SWIPELINC_API}merchant/onboard/save`;

export const MERCHANT_ONBOARD_VERIFIED = `${SWIPELINC_API}merchant/onboard/verified`;

export const MERCHANT_ONBOARD_OTP_CHANGE_EMAIL = `${SWIPELINC_API}merchant/verify-email/emailVerify`;

export const MERCHANT_ONBOARD_OTP_CHANGE_MOBILE = `${SWIPELINC_API}merchant/verify-email/mobileVerify`;

export const SEND_OTP_TO_MOBILE = `${SWIPELINC_API}merchant/verify-email/sendotpmobile`;

export const SEND_OTP_TO_EMAIL = `${SWIPELINC_API}merchant/verify-email/send-otp`;

export const CHECK_EMAIL_IS_VERIFIED_OR_NOT = `${SWIPELINC_API}merchant/onboard/verified/email`;

export const CHECK_MOBILE_IS_VERIFIED_OR_NOT = `${SWIPELINC_API}merchant/onboard/verified`;

export const GET_DASHBOARD_API = `${SWIPELINC_API}merchant/dashboard/getdashboard/`;

export const GET_DASHBOARD_AMOUNT_API = `${SWIPELINC_API}merchant/dashboard/getamountdata/`;

export const FETCH_MERCHANT_PROFILE = `${SWIPELINC_API}merchant/merchant-profile/getByMid/`;

export const VERIFY_CALLBACK_URLS = `${SWIPELINC_API}merchant/Util/getStatus`;

export const VIEW_PAYOUT_REQUEST_UPI_BY_MID = `${SWIPELINC_API}merchant/payoutRagister/findByMidWithStatusNotPending/`;

export const PAN_VERIFICATION = `${SWIPELINC_API}merchant/ekyc/panVerification`;

export const FETCH_REGISTRATION_TYPES = `${SWIPELINC_API}merchant/registration/getAllRegistrationType`;

export const FETCH_BUSINESS_CATEGORIES = `${SWIPELINC_API}merchant/business/getAllBusinessType`;

export const FETCH_BUSINESS_TYPE = `${SWIPELINC_API}merchant/company/getAllCompanyType`;

export const ADHAR_VERIFICATION = `${SWIPELINC_API}merchant/ekyc/aadhaarVerification`;

export const GST_VERIFICATION = `${SWIPELINC_API}merchant/ekyc/gstVerification`;

export const ADHAR_OTP_VERIFICATION = `${SWIPELINC_API}merchant/ekyc/aadhaarOtpVerification`;

export const FETCH_ALL_PAYMENT_TYPES = `${SWIPELINC_API}merchant/paymentType/getALLPaymentType`;

export const MERCHANT_ONBOARD_UPDATE = `${SWIPELINC_API}merchant/onboard/update`;

export const GUARANTEE_REPORT_FETCH = `${SWIPELINC_API}admin/guarantAmount/findAllByMid/`;

export const GET_ALL_RECONCIALIATION_DATA = `${SWIPELINC_API}merchant/reconsilation/getAll/reconciliationData`;

export const WITHDRAW_REQUEST_FETCH = `${SWIPELINC_API}merchant/withdrawal/findByMidWithStatusNotPending/`;

export const WALLET_BALANCE_REPORT_API = `${SWIPELINC_API}merchant/wallet/findByStatuss/`;

export const FETCH_RELEASE_BY_MID = `${SWIPELINC_API}merchant/release/getBy/`;

export const FETCH_HOLD_BY_MID = `${SWIPELINC_API}merchant/hold/getHoldReport/`;

export const GET_ALL_SETTLEMET_ADJUSTMENT_DATA = `${SWIPELINC_API}merchant/settlement/get-by-mid-and-remark/`;

export const FETCH_DEPOSIT_BY_MID = `${SWIPELINC_API}merchant/deposit/getDepositeReportByMid/`;

export const ACC_NUM_IFSC_VERIFY_API = `${SWIPELINC_API}merchant/ekyc/bankVerification`;

export const IFSC_VERIFY_API = `${SWIPELINC_API}merchant/ekyc/findByIfsc`;

export const MY_REFFERELS = `${SWIPELINC_API}merchant/onboard/myReferal/`;

export const LOG_OUT_API = `${SWIPELINC_API}merchant/login/logout`;

export const UPDATE_MERCHANT_BANK_DETAILS = `${SWIPELINC_API}merchant/onboard/savebankDetails`;

export const UPLOAD_MERCHANT_DOCS = `${SWIPELINC_API}merchant/onboard/savemerchantdocuments`;

export const CHECK_FILE_IS_PDF = `${SWIPELINC_API}merchant/onboard/checkPdf`;

export const GET_REPORT_API = `${SWIPELINC_API}LiveReport/allReports/tmeframe`;

export const GET_REPORT_API_CSV_TIMEFRAME = `${SWIPELINC_API}LiveReport/allReports/tmeframe/withoutPagination`;

export const CHANGE_PASSWORD_AFTER_LOGIN = `${SWIPELINC_API}merchant/onboard/changePassword`;

export const GET_ALL_SETTLEMENT = `${SWIPELINC_API}merchant/settlement/settlement/findBymid/`;

export const VIEW_E_KYC_REPORT = `${SWIPELINC_API}merchant/ekyc/userUses`;

// export const FETCH_ALL_VENDERS_BY_MID = `${SWIPELINC_API}merchant/vendor/getAllVendorByMid/`;
// export const FETCH_ALL_VENDERS_BY_MID = `${SWIPELINC_API}merchant/vendor/getAllVendorInfo`;
export const FETCH_ALL_VENDERS_BY_MID = `${SWIPELINC_API}merchant/vendor/vendor/details/`;
export const FETCH_DISABLED_VENDERS_BY_MID = `${SWIPELINC_API}merchant/vendor/vendors/`;

export const FETCH_ALL_EKYC = `${SWIPELINC_API}merchant/ekyc/userUses`;

export const FETCH_ALL_PAYIN_SERVICES = `${SWIPELINC_API}merchant/dashboard/getpaymentserviceswithpercentage/`;

export const GET_STATIC_QR = `${SWIPELINC_API}merchant/virtual-terminal/request/qr`;

export const POST_LINK_BASED_PAYMENT = `${SWIPELINC_API}merchant/link/save`;

export const VIRTUAL_TERMINAL_REQUEST_SUBMIT = `${SWIPELINC_API}merchant/virtual-terminal/request`;

export const CHECK_THIRD_PARTY_API_STATUS = `${SWIPELINC_API}merchant/third-party-service/get`;

export const VERIFY_UPI_API = `${SWIPELINC_API}merchant/ekyc/VPAVerification`;

export const VERIFY_VENDER_EMAIL = `${SWIPELINC_API}merchant/vendor/findByEmail/`;

export const VERIFY_VENDER_MOBILE = `${SWIPELINC_API}merchant/vendor/findByMobile/`;

export const VERIFY_VENDER_AADHAAR = `${SWIPELINC_API}merchant/ekyc/aadhaarVerification`;

export const VERIFY_VENDER_AADHAAR_OTP = `${SWIPELINC_API}merchant/ekyc/aadhaarOtpVerification`;

export const VERIFY_VENDER_PAN = `${SWIPELINC_API}merchant/ekyc/panVerification`;

export const SAVE_VENDER_DETAILS = `${SWIPELINC_API}merchant/vendor/saveMerchantWithDetails`;

export const UPDATE_VENDER_DETAILS = `${SWIPELINC_API}merchant/vendor/vendor/updateVendorInfo`;

export const UPDATE_VENDER_MOBILE = `${SWIPELINC_API}merchant/vendor/update-mobile`;

export const DISABLE_VENDOR = `${SWIPELINC_API}merchant/vendor/enable_disable_vendor/by-vendorId/`;

export const SETTLEMENT_MULTIPLE_FILTER_API = `${SWIPELINC_API}merchant/settlement/settlement/getSettlementByMultipalCondition`;

export const COMMON_MULTIPLE_FILTER_API = `${SWIPELINC_API}merchant/CSV/Download/multiplefilter`;

export const COMMON_ADVANCE_FILTER_API = `${SWIPELINC_API}merchant/CSV/Download/AdvanceFilter`;

export const WITHDRAW_MULTIPLE_FILTER_API = `${SWIPELINC_API}merchant/withdrawal/ByMultpalCondition`;

export const CHARGEBACK_MULTIPLE_FILTER_API = `${SWIPELINC_API}merchant/chargeback/chargeBack/ByMultpalCondition`;

export const GURANTEE_MULTIPLE_FILTER_API = `${SWIPELINC_API}admin/guarantAmount/ByMultpalCondition`;

export const PAYOUT_MULTIPLE_FILTER_API = `${SWIPELINC_API}merchant/payoutRagister/getPayoutByMultipleCondition`;

export const RECONCILIATION_MULTIPLE_FILTER_API = `${SWIPELINC_API}merchant/reconsilation/getReconciliationByMultipleConditions`;

export const FETCH_DATA_FOR_CHARGEBACK = `${SWIPELINC_API}merchant/chargeback/findbymid/`;

export const GET_REPORT_BY_CONDITION_API = `${SWIPELINC_API}merchant/reports/getreportByCondition`;

export const PAYIN_MULTIPLE_FILTER_API = `${SWIPELINC_API}merchant/reports/getreportByMultpalCondition`;

export const ADD_WALLET_BALANCE_API = `${SWIPELINC_API}merchant/wallet/save`;

export const SAVE_USER = `${SWIPELINC_API}merchant/subuser/save`;

export const USER_ENABLE_DISABLE = `${SWIPELINC_API}merchant/subuser/`;

export const GET_ALL_USER = `${SWIPELINC_API}merchant/subuser/getAllSubUsers/`;

export const GET_ALL_PRIVILAGES = `${SWIPELINC_API}merchant/privileg/getallwithsubprivileges`;

export const USER_UPDATE = `${SWIPELINC_API}merchant/subuser/subUsersUpdate`;

export const SAVE_MISSING_CALLBACK = `${SWIPELINC_API}merchant/missingCallback/save`;

export const FETCH_ALL_VENDERS_BY_STATUS_AND_MID = `${SWIPELINC_API}merchant/vendor/getAllVendorByStatus`;

export const UPLOAD_PAYOUT_TXN_CALLBACK_CSV = `${SWIPELINC_API}merchant/payoutRagister/csv/upload`;

export const WITHDRAWL_SAVE_PAYOUT = `${SWIPELINC_API}merchant/withdrawal/save`;

export const BALANCE_FETCH = `${SWIPELINC_API}merchant/payoutRagister/getBalance/`;

export const TRANSFER_AMOUNT = `${SWIPELINC_API}merchant/withdrawal/save`;

export const PENDING_WITHDRAW_REQUEST_FETCH = `${SWIPELINC_API}merchant/withdrawal/getWithdrawalByMidForAllTransactionStatusPending/`;


export const FETCH_ALL_MERCHANT_VALIDATIONS = `${SWIPELINC_API}merchant/getallmerchant-validation`;

export const FETCH_INVOICE = `${SWIPELINC_API}merchant/settlement/postpaid_settlement/findbymid/`; 

export const NOTIFICATION_DELETE_API = `${SWIPELINC_API}merchant/notification/Disable/`;

export const UPLOAD_CALLBACK_CSV = `${SWIPELINC_API}merchant/missingCallback/csv/upload`;

export const FIND_BY_ORDER_NO = `${SWIPELINC_API}merchant/reports/findByOrderNo`;

export const AVAILABLE_BALANCE_UPI_IMPS_WALLET = `${SWIPELINC_API}merchant/payoutRagister/getBalance/`;

export const GET_ALL_PAYOUT_REQUEST = `${SWIPELINC_API}merchant/payoutRequest/getAll/`;

export const PAYOUT_REQUEST_DELETE = `${SWIPELINC_API}merchant/payoutRequest/delete/`;

export const FIND_VENDOR_OR_CUSTOMER = `${SWIPELINC_API}merchant/vendor/`;

export const FETCH_FRM_USERS = `${SWIPELINC_API}merchant/frm-block/get/`;

export const FRM_BLOCK_USER = `${SWIPELINC_API}merchant/frm-block/save`;

export const API_DASHBOARD_WITH_CONDITION = `${SWIPELINC_API}merchant/dashboard/combined-api`;

export const CHANGED_API_DASHBOARD_WITH_CONDITION = `${SWIPELINC_API}merchant/dashboard/combined-api4`;

export const TREND_CHART_API = `${SWIPELINC_API}merchant/dashboard/getdashboardTrendchart/`;

export const REPORTS_BY_TIMEFRAME = `${SWIPELINC_API}LiveReport/allReports/tmeframe`;

export const REPORT_ERROR_CODES = `${SWIPELINC_API}LiveReport/getDataBy/tmeframe`;

export const GET_DOWNLOAD_CSV_OF_ARCHIEVE_REPORT = `${SWIPELINC_API}merchant/CSV/Download/payin`;

export const BOX_DATA_BY_CONDITION = `${SWIPELINC_API}LiveReport/getDataBy/condition`;

export const DECRYPT_CODE = `${SWIPELINC_API}paymentRequest/webBased`;

export const CALLBACK_URL = `${SWIPELINC_API}paymentRequest/callBackUrl/status`;

// export const FETCH_VENDER_DETAILS_BY_VENDER_ID = `${SWIPELINC_API}merchant/vendor/getVendorById/`;
export const FETCH_VENDER_DETAILS_BY_VENDER_ID = `${SWIPELINC_API}merchant/vendor/getVendorsInfoByid/`;

export const FETCH_VENDER_OLD_ACCOUNTS_DETAILS_BY_VENDER_ID = `${SWIPELINC_API}merchant/vendor/get_old_beneficiary_vendor_details/`;

export const PAYOUT_URL = `${SWIPELINC_API}paymentRequest/payout`;

export const COMPANY_PAN_VERIFICATION = `${SWIPELINC_API}paymentRequest/ekyc/panVerification`;

export const COMPANY_ADHAAR_VERIFICATION = `${SWIPELINC_API}paymentRequest/ekyc/aadhaarVerification`;

export const COMPANY_AADHAR_OTP_VERIFICATION = `${SWIPELINC_API}paymentRequest/ekyc/aadhaarOtpVerification`;

export const COMPANY_GST_VERIFICATION = `${SWIPELINC_API}paymentRequest/ekyc/gstVerification`;

export const BANK_VERIFICATION = `${SWIPELINC_API}paymentRequest/ekyc/bankVerification`;

export const GET_ALL_NOTICE = `${SWIPELINC_API}merchant/notification/images/notification`;

export const FRM_URL = `${SWIPELINC_API}paymentRequest/frmMethod`;

export const PAYOUT_REQ_SAVE = `${SWIPELINC_API}merchant/payoutRagister/save`;

export const SAVE_PAYOUT_REQUEST = `${SWIPELINC_API}merchant/payoutRequest/save`;

export const GET_ALL_DEBIT = `${SWIPELINC_API}getAllDebit`;

export const GET_ALL_CREDIT = `${SWIPELINC_API}getAll`;

export const ONBOARDING_URL = `${SWIPELINC_API}merchant/onboard/saveMerchantDetails`;

export const SAVE_IMAGE_URL = `${SWIPELINC_API}merchant/onboard/upload`;

export const ACCEPT_OR_REJECT = `${SWIPELINC_API}merchant/reports/findByOrderNumber`;

export const GET_RESPONSE_CODE = `${SWIPELINC_API}admin/payin/findByTxnId/`;

export const PAYOUT_BALANCE_DEATILS = `${SWIPELINC_API}merchant/merchantLoginMasterController/findByMid/`;

export const SEND_CALLBACK = `${SWIPELINC_API}merchant/sendPayinCallback/`;

export const UPDATE_PROFILE = `${SWIPELINC_API}merchant/merchant-profile/updateProfile`;

export const ADD_UTR_TO_PAYIN_TXN = `${SWIPELINC_API}reportedPayinIssueController/saveReportedPayinIssue`;

export const REQUEST_FOR_ZP = `${SWIPELINC_API}merchant/virtual-terminal/requestforZenepeAmount`;
